import {PickupRequest} from '../Components/PickupResponseAndRequest'
import {Method, useHttp} from './useHttp'

export const usePickupOrder = (request: PickupRequest | undefined, agreementCode: string, doRequest: boolean) => {
  const {isLoading, isError, responseData} = useHttp({
    path: `/pickupOrder/${encodeURIComponent(agreementCode)}`,
    method: Method.POST,
    stringifiedRequestBody: JSON.stringify(request),
    doRequest: doRequest,
    initialData: {},
  })

  return {isLoading, isError, responseData}
}
